module.exports = __webpack_public_path__ + "img/company.782c4f29.svg";